<template>
	<div class="mapBox">
		<div class="map">
			<div class="mapGoogle" id="map"></div>
			<div class="nav" :style="{left:navShow?'0':'-310px'}">
				<div class="btn" @click="navShow=!navShow">
					{{navShow?'收起':'展开'}}				
					<img :style="{transform:navShow?'rotate(0deg)':'rotate(180deg)'}" src="./img/hsj.png"></div>
				<h3>江泰驻海外办事处</h3>
				<ul class="height">
					<li v-for="(item,index) in bscList" @click="setCenter(item);activeIndex=index">
						<p>{{item.name}}</p>
						<p :class="{active:activeIndex == index}" >{{item.cityName}}</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import layoutImg from "./img/layout.png"	
	import { getMissionsOverseas } from '@/views/axios/api.js';
	export default{
		data(){
			return {
				navShow:false,
				mapNode:null,
				bscList:[],
				fwInfowindow:[],//标记信息
				activeIndex:''
			}
		},
		mounted(){
			this.init();
			this.getMissionsOverseas()
		},
		methods:{
			init(){//初始化地图
		        //中心点设置
		        var _this=this;
		        var center={lat: 35.7, lng: 151.416667}
				this.mapNode = new google.maps.Map(document.getElementById('map'), {
				  center,
				  minZoom:2,
				  zoom: 2
				});	
				//自定义地图的显示范围：中国区域内部  
				var strictBounds = new google.maps.LatLngBounds(  
				    new google.maps.LatLng(14.48003790418668, 66.28120434863283),   
				    new google.maps.LatLng(54.44617552862156, 143.71284497363283  
				));  
				google.maps.event.addListener(this.mapNode, 'dragend',  
				function() { 
			        if(_this.mapNode)
			        {
			          var maxX = _this.mapNode.getBounds().getNorthEast().lng();
			          var maxY = _this.mapNode.getBounds().getNorthEast().lat();
			          var minX = _this.mapNode.getBounds().getSouthWest().lng();
			          var minY = _this.mapNode.getBounds().getSouthWest().lat();
			          if (maxY > 85.2 || minY < -85){
			            _this.mapNode.panTo(new google.maps.LatLng(35.05859375, 0.580078125));
			            return;
			          }
			        }
				});				
				this.getMissionsOverseas();				
			},
			getMissionsOverseas(){
				getMissionsOverseas()
				.then(res =>{
					this.bscList=res.data.obj;
					this.mapFun()
				})
				.catch(err=>{
					console.log(err)
				})
			},
			mapFun(){
		        //点击弹窗提示
		        var _this=this;
		        	function content(data){
		        		var contentString =`<div class='layoutBox'>
				        						<video class='vioce' src='${data.url}' controls></video>
				        						<div>
				        							<p class='text1'>${data.name}</p>
				        							<p class='text2'>成立时间:${data.date}</p>
				        							<p class='icon1'>${data.cityName}</p>
				        							<p class='icon2'>${data.userName}</p>
				        							<p class='icon3'>${data.tel}</p>
				        						</div>
				        					</div>`;
        				return contentString
		        	}

			
				//标记设置
				this.bscList.forEach((feature,index)=> {
		          var marker = new google.maps.Marker({
		            position: new google.maps.LatLng(feature.lat, feature.lng),
		            icon: layoutImg,
		            map: this.mapNode,
		            title: '我是标记'
		          });
			        var infowindow = new google.maps.InfoWindow({
			          content: content(feature)
			        });	        
			        marker.addListener('click', function() {
			        	if(_this.fwInfowindow.length != 0){
							_this.fwInfowindow.forEach((item,index)=>{
								_this.fwInfowindow[index].infowindow.close()
							})			        		
			        	}
			        	infowindow.open(map, marker);
			        	_this.fwInfowindow.push({infowindow})
			        });
		      });
			},
			setCenter(value){
				this.mapNode.setCenter(new google.maps.LatLng(value.lat, value.lng))
				this.mapNode.setZoom(3);
			},			
		}
	}
</script>
<style>	
	body, html{zoom: 1;height: 100%;width: 100%;}
	.gm-style-mtc ,.gm-svpc{display: none;}
	.gm-control-active,.gm-fullscreen-control{display: none;}
	.layoutBox .vioce{width: 230px;height: 130px;}
	.layoutBox .text1{color: #333;font-size: 16px;font-weight: 600;margin-top: 5px;}
	.layoutBox .text2{margin-top: 5px;font-size: 12px;}
	.layoutBox .icon1{background: url(./img/dingwei.png) left center no-repeat;padding-left: 20px;background-size: 15px;margin-top: 5px;}
	.layoutBox .icon2{background: url(./img/people.png) left center no-repeat;padding-left: 20px;background-size: 15px;margin-top: 5px;}
	.layoutBox .icon3{background: url(./img/iphone.png) left center no-repeat;padding-left: 20px;background-size: 15px;margin-top: 5px;}
</style>
<style scoped="scoped">
	* {box-sizing: border-box;}
	.map{width: 100vw;height: 100vh;position: relative;color: #333;}
	.map >.mapGoogle{height: 100%;width: 100%;}
	.map .nav{width: 310px;background: white;position: absolute;top: 0;left: 0;transition:all 0.5s}
	.btn{position: absolute;top: 80px ;right: -30px;color: #666;width: 30px;background: white;font-size: 14px;text-align: center;padding: 5px;cursor: pointer;}
	.map .nav h3{font-weight: normal;font-size: 16px;line-height: 50px;text-align: center;border-bottom: 1px solid #eee;border-right: 1px solid #eee}
	.map .nav li{padding: 10px;}
	.map .nav li p:first-child{font-size: 16px;}
	.map .nav li p:last-child{font-size: 12px;color: #666;line-height: 25px;background: url(./img/dingwei.png) no-repeat left 2px;background-size: 15px;padding-left: 20px;margin-top: 5px;padding-bottom: 5px;}
    .height{height: calc(100vh - 51px);overflow-y: auto;border-right: 1px solid #eee;}
    .active{border-bottom: 2px solid #00A4EF;}
</style>


// WEBPACK FOOTER //
// src/views/map/layout.vue